import { render, staticRenderFns } from "./Evaluation_list.vue?vue&type=template&id=cb1482a0&scoped=true"
import script from "./Evaluation_list.vue?vue&type=script&lang=js"
export * from "./Evaluation_list.vue?vue&type=script&lang=js"
import style0 from "./Evaluation_list.vue?vue&type=style&index=0&id=cb1482a0&prod&scoped=true&lang=css"
import style1 from "./Evaluation_list.vue?vue&type=style&index=1&id=cb1482a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1482a0",
  null
  
)

export default component.exports